export default class PasswordResetModel {
  public password = "";
  public confirmPassword = "";

  constructor(data?: unknown) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
